import { Empty } from 'antd';

import Box from '../../../components/Box';
import SpaceSpinner from '../../../components/SpaceSpinner';
import { hasCompanyManagerOrAdminRole } from '../../../utils/roles';
import DriverDeadlineView from '../DriverDeadlineView';
import ReimbursementPipeline from '../ReimbursementPipeline';
import useDashboardScheduleTimeline from '../useDashboardScheduleTimeline';
import classNames from './styles.module.scss';

const DashboardScheduleTimeline = props => {
  const {
    t,
    selectedGroupId,
    timelineFilters,
    timeline,
    isTimelineLoading,
    dashboardData,
    onPeriodChange,
  } = props;

  const {
    isLoading,
    paymentSchedules,
    deadlineGroups,
    currentPeriod,
    nextPeriod,
    isTimelineSectionLoading,
  } = useDashboardScheduleTimeline({
    t,
    user: props.user,
    selectedGroupId,
    timelineFilters,
    timeline,
    isTimelineLoading,
  });

  const showSectionSpinner = isLoading || (!paymentSchedules.length && isLoading);

  if (showSectionSpinner) {
    return (
      <Box className={classNames.wrapper}>
        <SpaceSpinner height={320} />
      </Box>
    );
  }

  if (!paymentSchedules.length) {
    return (
      <Box className={classNames.wrapper}>
        <Empty description={t('noPaymentScheduleAvailable')} />
      </Box>
    );
  }

  if (hasCompanyManagerOrAdminRole(props.user)) {
    return (
      <div className={classNames.wrapper}>
        <ReimbursementPipeline
          t={t}
          timeline={timeline}
          timelineFilters={timelineFilters}
          isTimelineLoading={isTimelineSectionLoading}
          onPeriodChange={onPeriodChange}
        />
      </div>
    );
  }

  return (
    <div className={classNames.wrapper}>
      <DriverDeadlineView
        t={t}
        currentPeriod={currentPeriod}
        nextPeriod={nextPeriod}
        deadlineGroups={deadlineGroups}
        dashboardData={dashboardData}
        driverStatus={dashboardData?.driverStatus}
      />
    </div>
  );
};

export default DashboardScheduleTimeline;
